<template>
  <div class="publications-container">
    <div class="title-section">
      <div class="title">
        <span>发表论文</span>
      </div>
      <div class="title-line"></div>
      <div class="title-subtitle">Publications</div>
    </div>

    <div class="search-section" v-if="publicationList.length > 0">
      <el-form :inline="true" :model="form" class="search-form">
        <el-form-item label="Title" class="search-item">
          <el-input
            v-model="form.title"
            placeholder="Search by title"
            class="search-input"
          ></el-input>
        </el-form-item>
        <el-form-item label="Author" class="search-item">
          <el-input
            v-model="form.author"
            placeholder="Search by author"
            class="search-input"
          ></el-input>
        </el-form-item>
        <el-form-item class="search-item">
          <el-button type="primary" @click="onSubmit" class="search-btn">
            <i class="el-icon-search"></i> Search
          </el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="list-container" v-loading="loading" element-loading-text="Loading..." element-loading-spinner="el-icon-loading" element-loading-background="rgba(255, 255, 255, 0.95)">
      <div
        class="publication-card"
        v-for="(item, index) in publicationList"
        :key="index"
        :style="{ animationDelay: index * 0.08 + 's' }"
      >
        <div class="card-content">
          <div class="card-left">
            <div class="card-badge">{{ item.publishJournals }}</div>
            <h3 class="card-title">{{ item.title }}</h3>
            <div class="card-author">
              <span class="author-label">Author:</span>
              <span class="author-name">{{ item.author }}</span>
            </div>
            <div class="card-journal">{{ item.publishJournals }}</div>
            <a
              v-if="item.linkUrl"
              :href="item.linkUrl"
              target="_blank"
              class="card-link"
            >
              <i class="el-icon-external-link"></i> {{ item.linkName || 'View Details' }}
            </a>
          </div>
          <div class="card-right">
            <div class="image-wrapper">
              <el-image
                :src="item.image"
                fit="cover"
                class="card-image"
              />
              <div class="image-overlay">
                <i class="el-icon-zoom-in"></i>
              </div>
            </div>
          </div>
        </div>
        <div class="card-footer">
          <div class="card-index">#{{ index + 1 }}</div>
          <div class="card-decoration"></div>
        </div>
      </div>

      <div v-if="!loading && publicationList.length === 0" class="empty-state">
        <div class="empty-icon">
          <i class="el-icon-document"></i>
        </div>
        <p class="empty-text">No publications found</p>
        <p class="empty-hint">Try adjusting your search criteria</p>
      </div>
    </div>
  </div>
</template>

<script>
import { listPublication } from '@/api/api'
export default {
  data () {
    return {
      form: {},
      publicationList: [],
      loading: true
    }
  },
  created () {
    this.listPublication()
  },
  methods: {
    onSubmit () {
      this.listPublication()
    },
    listPublication () {
      this.loading = true
      listPublication(this.form).then(res => {
        if (res.code === 200) {
          let item = res.data.sort((a, b) => {
            return b.sortNum - a.sortNum
          })
          this.publicationList = item
        }
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>

<style scoped>
.publications-container {
  min-height: 600px;
}

.title-section {
  position: relative;
  margin-bottom: 32px;
}

.title {
  font-size: 36px;
  line-height: 1.4;
  color: #2f4f4f;
  font-weight: 700;
  letter-spacing: 3px;
  animation: titleFloatIn 0.8s cubic-bezier(0.22, 1, 0.36, 1) forwards;
}

@keyframes titleFloatIn {
  from {
    opacity: 0;
    transform: translateY(-40px);
    letter-spacing: 10px;
  }
  to {
    opacity: 1;
    transform: translateY(0);
    letter-spacing: 3px;
  }
}

.title-line {
  position: absolute;
  bottom: -8px;
  left: 0;
  width: 80px;
  height: 4px;
  background: linear-gradient(90deg, #2f4f4f, #5a8a8a);
  border-radius: 2px;
  animation: lineSlideIn 1s cubic-bezier(0.22, 1, 0.36, 1) 0.3s forwards;
  transform-origin: left;
  transform: scaleX(0);
}

@keyframes lineSlideIn {
  from {
    transform: scaleX(0);
  }
  to {
    transform: scaleX(1);
  }
}

.title-subtitle {
  position: absolute;
  right: 0;
  top: 10px;
  font-size: 14px;
  color: #888;
  letter-spacing: 8px;
  text-transform: uppercase;
  animation: subtitleFadeIn 0.8s cubic-bezier(0.22, 1, 0.36, 1) 0.5s forwards;
  opacity: 0;
}

@keyframes subtitleFadeIn {
  from {
    opacity: 0;
    transform: translateX(20px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

.search-section {
  animation: searchSlideDown 0.6s cubic-bezier(0.22, 1, 0.36, 1) 0.4s forwards;
  opacity: 0;
  transform: translateY(-10px);
}

@keyframes searchSlideDown {
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.search-form {
  padding: 20px 24px;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-radius: 12px;
  box-shadow: 0 4px 15px rgba(47, 79, 79, 0.08);
}

.search-item {
  margin-bottom: 0;
}

.search-input {
  width: 220px;
  border-radius: 8px;
  transition: all 0.3s ease;
}

.search-input:focus {
  box-shadow: 0 0 0 3px rgba(47, 79, 79, 0.1);
  border-color: #2f4f4f;
}

.search-btn {
  background: linear-gradient(135deg, #2f4f4f 0%, #3d5a5a 100%);
  border: none;
  border-radius: 8px;
  padding: 10px 24px;
  font-weight: 600;
  transition: all 0.3s ease;
}

.search-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(47, 79, 79, 0.3);
}

.list-container {
  margin-top: 24px;
}

.publication-card {
  position: relative;
  margin-bottom: 20px;
  opacity: 0;
  animation: cardSlideIn 0.7s cubic-bezier(0.22, 1, 0.36, 1) forwards;
}

@keyframes cardSlideIn {
  from {
    opacity: 0;
    transform: translateX(-50px) translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateX(0) translateY(0);
  }
}

.card-content {
  display: flex;
  gap: 24px;
  padding: 24px;
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(47, 79, 79, 0.06);
  border: 1px solid rgba(47, 79, 79, 0.08);
  transition: all 0.4s cubic-bezier(0.22, 1, 0.36, 1);
}

.publication-card:hover .card-content {
  transform: translateY(-4px);
  box-shadow: 0 12px 35px rgba(47, 79, 79, 0.12);
  border-color: rgba(47, 79, 79, 0.15);
}

.card-left {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.card-badge {
  display: inline-block;
  padding: 4px 12px;
  background: linear-gradient(135deg, rgba(47, 79, 79, 0.1) 0%, rgba(47, 79, 79, 0.05) 100%);
  color: #2f4f4f;
  font-size: 12px;
  font-weight: 600;
  border-radius: 20px;
  width: fit-content;
  animation: badgePop 0.3s ease 0.3s forwards;
  opacity: 0;
}

@keyframes badgePop {
  from {
    opacity: 0;
    transform: scale(0.8);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

.card-title {
  font-size: 20px;
  font-weight: 600;
  color: #2f4f4f;
  line-height: 1.5;
  margin: 0;
  transition: color 0.3s ease;
}

.publication-card:hover .card-title {
  color: #3d5a5a;
}

.card-author {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
}

.author-label {
  color: #888;
  font-weight: 500;
}

.author-name {
  color: #2f4f4f;
  font-weight: 600;
}

.card-journal {
  font-size: 14px;
  color: #666;
  font-style: italic;
}

.card-link {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: #2f4f4f;
  font-size: 14px;
  font-weight: 500;
  text-decoration: none;
  padding: 8px 16px;
  background: rgba(47, 79, 79, 0.05);
  border-radius: 8px;
  width: fit-content;
  transition: all 0.3s ease;
  margin-top: 8px;
}

.card-link:hover {
  background: #2f4f4f;
  color: #fff;
  transform: translateX(5px);
}

.card-right {
  flex-shrink: 0;
  width: 280px;
}

.image-wrapper {
  position: relative;
  border-radius: 12px;
  overflow: hidden;
  height: 180px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transition: all 0.4s cubic-bezier(0.22, 1, 0.36, 1);
}

.publication-card:hover .image-wrapper {
  transform: scale(1.05);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
}

.card-image {
  width: 100%;
  height: 100%;
}

.image-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(47, 79, 79, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.3s ease;
  cursor: pointer;
}

.image-wrapper:hover .image-overlay {
  opacity: 1;
}

.image-overlay i {
  font-size: 32px;
  color: #fff;
}

.card-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 24px 0;
  margin-top: -8px;
}

.card-index {
  font-size: 12px;
  color: #aaa;
  font-weight: 500;
}

.card-decoration {
  flex: 1;
  height: 1px;
  background: linear-gradient(90deg, rgba(47, 79, 79, 0.1) 0%, rgba(47, 79, 79, 0.02) 100%);
  margin-left: 16px;
}

.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 80px 20px;
  animation: emptyFadeIn 0.6s ease forwards;
}

@keyframes emptyFadeIn {
  from {
    opacity: 0;
    transform: scale(0.95);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

.empty-icon {
  width: 100px;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #f0f0f0 0%, #e0e0e0 100%);
  border-radius: 50%;
  margin-bottom: 24px;
}

.empty-icon i {
  font-size: 48px;
  color: #aaa;
}

.empty-text {
  font-size: 18px;
  color: #666;
  margin: 0 0 8px;
}

.empty-hint {
  font-size: 14px;
  color: #999;
  margin: 0;
}

@media (max-width: 900px) {
  .card-content {
    flex-direction: column;
  }

  .card-right {
    width: 100%;
  }

  .image-wrapper {
    height: 220px;
  }
}
</style>
